<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">

      <section class="talkshow">

        <div class="talkshowTitle">
          <div class="inner4">
            <h1>ヒカリエトークステージレポート</h1><p class="titleSub">Official Exhibition Events Reports</p>
          </div><!-- /inner4-->
        </div><!-- /talkshowTitle-->

        <div class="talkshowAbout">
          <div class="inner4">
            <p>
              オフライン展示 in Hikarieで開催したトークショーレポートです。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->

        <div class="scheduleMenu">
          <div class="scheduleMenuDate" :class="{positionFixed: isScroll}" ref="schedule">
            <div class="inner4">
              <div v-if="reportsDateListByMonth[9]" class="scheduleMenuLink m11" :class="{withRightLine: !reportsDateListByMonth[10]}">
                <p>9月</p>
                <ul class="" style="list-style: none; padding-left: 0px;">
                  <template v-for="date in reportsDateListByMonth[9]">
                    <li :key="date">
                      <a style="cursor: pointer;" :class="{ pastColor: isFutureDate(9,date) }" href="#" v-scroll-to="{el:'.d09'+('00' + String(date)).slice(-2),offset:getScrollOffset()}">{{date}}<span>日</span></a>
                    </li>
                  </template>
                </ul>
              </div>
              <div v-if="reportsDateListByMonth[10]" class="scheduleMenuLink m12" :class="{withLeftLine: !reportsDateListByMonth[9]}">
                <p>10月</p>
                <ul class="" style="list-style: none; padding-left: 0px;">
                  <template v-for="date in reportsDateListByMonth[10]">
                    <li :key="date">
                      <a style="cursor: pointer;" :class="{ pastColor: isFutureDate(10,date) }" href="#" v-scroll-to="{el:'.d10'+('00' + String(date)).slice(-2),offset:getScrollOffset()}">{{date}}<span>日</span></a>
                    </li>
                  </template>
                </ul>
              </div>
            </div><!-- /inner-->
          </div><!-- /scheduleMenuDate-->
          <!-- スケジュールがfixedになると、ref="schedule"のdivが無くなって上方ずれるので、fixedと同時に下記のdivを有効して、ズレをなくす -->
          <div :style="{ display: isScroll ? 'block' : 'none' }" ref="scheduleSpacer">&nbsp;</div>
          <div class="scheduleList">
            <div class="inner4">
              <div class="scheduleListBlock">
                <template v-for="report in reports">
                  <div v-if="!isScheduledTime(report.endAt)" :key="report.id">
                    <div :class="'d' + report.startAt.substr(5, 2) + report.startAt.substr(8, 2)"></div>
                    <ReportBox
                        :report="report"
                        mode="archives"
                        :nowDateTime.sync="nowDateTime"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import ReportBox from '@/components/modules/ReportBox.vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  components: {
    Header,
    Footer,
    ReportBox,
    UpButton
  },
  data () {
    return {
      nowDateTime: null,
      timerId: null,
      holidayList: ['9月19日', '9月23日', '10月10日'],
      isScroll: false,
      schedulePositionY: 0,
      reports: [
        {
            "id": 2,
            "winnerId": null,
            "eventType": 1,
            "title": "なぜ人々は「北海道東川町」に惹き付けられるのか",
            "description": "",
            "speakers": "東京カメラ部10選　井上浩輝氏、北海道「写真の町」東川町　東川町文化ギャラリー学芸員　吉里演子氏、東京カメラ部運営",
            "clients": "東川町・ひがしかわ観光協会",
            "startAt": "2022-09-17T16:00:00.000+09:00",
            "endAt": "2022-09-17T16:45:00.000+09:00",
            "thumbnail": "",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/higashikawa",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 5,
            "winnerId": null,
            "eventType": 1,
            "title": "僕らの写真時代",
            "description": "",
            "speakers": "写真家 鈴木さや香氏、キヤノンマーケティングジャパン株式会社　斉藤舞子氏",
            "clients": "キヤノンマーケティングジャパン",
            "startAt": "2022-09-17T17:30:00.000+09:00",
            "endAt": "2022-09-17T18:15:00.000+09:00",
            "thumbnail": "",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/canon",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 6,
            "winnerId": null,
            "eventType": 1,
            "title": "丘のまち風景写真の源流～美瑛町と前田真三",
            "description": "",
            "speakers": "北海道美瑛町長 角和浩幸氏、株式会社拓真館 館長 前田景氏",
            "clients": "美瑛町（ＮＰＯ法人　美瑛町写真映像協会）",
            "startAt": "2022-09-18T14:30:00.000+09:00",
            "endAt": "2022-09-18T15:15:00.000+09:00",
            "thumbnail": "",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/biei",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/biei/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 3,
            "winnerId": null,
            "eventType": 1,
            "title": "\"オリジナリティ\"とはレタッチで決まる！ raytrekで叶える写真のレベルアップ",
            "description": "",
            "speakers": "東京カメラ部10選・raytrekアンバサダー　別所隆弘氏、株式会社サードウェーブ　raytrek担当　黒川氏・片倉氏",
            "clients": "サードウェーブ",
            "startAt": "2022-09-18T16:00:00.000+09:00",
            "endAt": "2022-09-18T16:45:00.000+09:00",
            "thumbnail": "",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/thirdwave",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/thirdwave/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 4,
            "winnerId": null,
            "eventType": 1,
            "title": "LEICA x LUMIX コムロミホトークイベント",
            "description": "",
            "speakers": "写真家 コムロミホ氏、ライカカメラジャパン株式会社 米山和久氏",
            "clients": "パナソニック エンターテインメント＆コミュニケーション、ライカカメラジャパン",
            "startAt": "2022-09-19T13:00:00.000+09:00",
            "endAt": "2022-09-19T13:45:00.000+09:00",
            "thumbnail": "",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/leicalumix",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/leicalumix/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 9,
            "winnerId": null,
            "eventType": 1,
            "title": "東京カメラ部10選U-22と次の未来を語る ～新世代のNikon Creators～",
            "description": "",
            "speakers": "東京カメラ部10選U-22　池田拓海氏、東京カメラ部10選U-22　酒井雄世氏、東京カメラ部10選　石田卓士氏、東京カメラ部10選　半田菜摘氏",
            "clients": "ニコンイメージングジャパン",
            "startAt": "2022-09-19T14:30:00.000+09:00",
            "endAt": "2022-09-19T15:15:00.000+09:00",
            "thumbnail": "ptZQJ6kTIJM59kUR0n6vLv2BOdfZXLxh",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/nikon_u22",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 1,
            "winnerId": null,
            "eventType": 1,
            "title": "公式写真集＆ムック本発売記念「美しい世界との出会い」",
            "description": "",
            "speakers": "東京カメラ部10選　宇賀地尚子氏、東京カメラ部10選　木村知佳氏、東京カメラ部10選　Koichi氏、東京カメラ部10選　柳楽航平氏、日経ナショナル ジオグラフィック 書籍編集長 尾崎憲和氏、東京カメラ部運営",
            "clients": "日経ナショナル ジオグラフィック",
            "startAt": "2022-09-19T16:00:00.000+09:00",
            "endAt": "2022-09-19T16:45:00.000+09:00",
            "thumbnail": "ptZQJ6kTIJM59kUR0n6vLv2BOdfZXLxh",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/natgeo",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
        {
            "id": 7,
            "winnerId": null,
            "eventType": 1,
            "title": "【東京カメラ部2022写真展】カウントダウントークショー「写真との出会いは、世界との出会いだ。」",
            "description": "",
            "speakers": "東京カメラ部10選　井上裕康氏、東京カメラ部10選　小林 淳氏、東京カメラ部10選　shabon氏、東京カメラ部10選　恒松泰至氏、東京カメラ部運営",
            "clients": "東京カメラ部",
            "startAt": "2022-09-19T18:45:00.000+09:00",
            "endAt": "2022-09-19T19:45:00.000+09:00",
            "thumbnail": "ptZQJ6kTIJM59kUR0n6vLv2BOdfZXLxh",
            "icon": null,
            "liveLink": "",
            "reportLink": "/reports/tcc",
            "archiveLink": "",
            "thumbnailUrl": "https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/thumbnail.jpg",
            "iconUrl": null,
            "winnerName": "東京カメラ部運営"
        },
      ],
      reportsDateList: [],
      reportsDateListByMonth: [],
      reportsByDate: []
    }
  },
  created () {
    this.setNow()

    // データ生成
    for (const report of this.reports) {
      const date = moment(report.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M月D日')
      const month = moment(report.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M')
      const day = moment(report.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('D')

      // 月一覧を作成
      if (!this.reportsDateListByMonth[month]) {
        this.$set(this.reportsDateListByMonth, month, [])
      }
      // 日付一覧を作成
      if (!this.reportsByDate[date]) {
        this.$set(this.reportsByDate, date, [])
        this.reportsDateList.push(date)
        this.reportsDateListByMonth[month].push(day)
      }
      // 日付をキーにしたリストの作成
      this.reportsByDate[date].push(report)
    }
  },
  beforeDestroy () {
    clearInterval(this.timerId)
    window.removeEventListener('scroll', this.scrollHandler)
  },
  mounted () {
    // スクロールイベント設定
    window.addEventListener('scroll', this.scrollHandler)
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    // 過去日付の場合falseを返す
    isScheduledDate (talkShowsDate) {
      if (this.nowDateTime > moment('2022年' + talkShowsDate, 'YYYY年M月D日').tz('Asia/Tokyo').endOf('day').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    // トークショーが終了している場合falseを返す
    isScheduledTime (endTime) {
      if (this.nowDateTime > moment(endTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    scrollHandler () {
      if ((!this.schedulePositionY || this.schedulePositionY < 0 )  && this.$refs.schedule) {
        const rect = this.$refs.schedule.getBoundingClientRect()
        this.$refs.scheduleSpacer.style.height = this.$refs.schedule.offsetHeight + 'px'
        this.schedulePositionY = rect.top + window.scrollY
      }
      if (window.scrollY > this.schedulePositionY) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    getScrollOffset () {
      return -107
    },
    isFutureDate(month,date) {
      const key = month +'月'+date+'日'
      if(!this.isScheduledDate(key)) {
        return false
      } else if(this.nowDateTime.substr(0,4) =='2022' && Number(this.nowDateTime.substr(4,2)) == month && Number(this.nowDateTime.substr(6,2)) == date){
        // 当日の場合、終了しているトークショーがあればfalse
        if(!this.isScheduledTime(this.reportsByDate[key][0].endAt)) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    ...mapGetters([
      'talkShows',
      'talkShowsDateList',
      'talkShowsByDate',
      'talkShowsDateListByMonth'
    ]),
    dispDate: function () {
      return function (date) {
        if (date) {
          let dispDate = moment('2022年' + date, 'YYYY年M月D日').tz('Asia/Tokyo').format('M月D日（ddd）')
          if (this.holidayList.indexOf(date) >= 0) {
            dispDate = dispDate.slice(0, -1) + '・祝）'
          }
          return dispDate
        }
      }
    }
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.positionFixed {
  top: 0;
  width:100%;
  position: fixed;
  z-index:1000;
}

.pastColor {
  color: #B7B7B7;
  pointer-events: none;
}
</style>
